import { ConversationResp } from '@marketplace-web/messaging/conversation-messaging-data'
import { api } from '@marketplace-web/core-api/core-api-client-util'

export const declineComplaintResolved = (conversationId: number | string) =>
  api.patch<ConversationResp>(`/conversations/${conversationId}/complaint/refuse_resolved`)

export const confirmComplaintResolved = (conversationId: number | string) =>
  api.patch<ConversationResp>(`/conversations/${conversationId}/complaint/confirm_resolved`)
